import { render } from "./orderArchive.vue?vue&type=template&id=6a7f512c"
import script from "./orderArchive.vue?vue&type=script&lang=js"
export * from "./orderArchive.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__